import { render, staticRenderFns } from "./zoom-slider.svg.vue?vue&type=template&id=32d1492a&"
import script from "./zoom-slider.svg.vue?vue&type=script&lang=js&"
export * from "./zoom-slider.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports